import React from 'react';

import LoginForm from '../LoginForm/LoginForm';


const LandingPage = () => <LoginForm />;

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/Pages/Login/LandingPage/LandingPage.js